<template>
    <ValidationObserver tag="form" ref="observer" class="row" @submit.prevent="submit">
        <div class="col-12">
            <div class="form-group">
                <label for="producto">Producto</label>
                <ValidationProvider name="producto" rules="required" v-slot="{ errors }">
                    <multiselect
                        id="producto"
                        :options="productos"
                        :class="(errors[0] ? 'is-invalid' : '')"
                        :disabled="desactivar"
                        v-model="localProduct.productoSeleccionado"
                        placeholder="Producto"
                        track-by="id"
                        label="name"
                        data-cy="select-add-producto"
                    />
                    <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
                </ValidationProvider>
            </div>
            <div class="form-group">
                <label for="stock">Stock</label>
                <ValidationProvider name="stock" rules="required" v-slot="{ errors }">
                    <input type="number" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Stock" v-model="localProduct.stock"/>
                    <span v-if="errors[0]" id="exampleInputStock1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="form-group">
                <label for="precio">Precio</label>
                <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                    <input type="number" step="0.01" min="0" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Precio" v-model="localProduct.precio"/>
                    <span v-if="errors[0]" id="exampleInputPrecio1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-12 mt-3">
            <b-button
                id="submit-add-producto"
                type="submit"
                :disabled="loading"
                data-cy="submit-add-producto"
            >
                Continuar
            </b-button>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['producto', 'products', 'desactivar'],
        data() {
            return {
                productos: [],
                loading: false,
                localProduct: {... this.producto }
            }
        },
        methods: {
            getProductos() {
                this.loading = true;

                const params = {
                    filters: {
                        to_select: true
                    },
                    teatro_id: this.teatro.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.productos.index'), params).then(res => {
                    this.productos = res.data.data.filter(producto => {
                        return !this.products.some(p => p.id === producto.id);
                    });
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.localProduct.id = this.localProduct.productoSeleccionado.id;
                    Object.assign(this.producto, this.localProduct);
                    this.$emit('terminado');
                }
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            this.getProductos();
        }
    }
</script>